import { useAppSelector } from "../../store/hooks";
import {
  selectCurrentUser,
  selectLoggedUser,
} from "../../store/selectors/authSelectors";
import { UserRoleE } from "../../models/enums";

/**
 * Retrieve logged user if it exists
 * */

export const useAuth = () => {
  const currentUser = useAppSelector(selectCurrentUser);
  const loggedUsers = useAppSelector(selectLoggedUser);
  const isLogged = !!currentUser;
  const userRole = currentUser?.role;

  // check if current logged user has access rights of the specified user
  const hasAccessRightsOf = (role: UserRoleE | UserRoleE[] | undefined) => {
    // shows for all visitors
    if (!role) return true;

    // check if current user exists
    if (!isLogged) return false;

    // check is role arg array
    if (role instanceof Array) {
      // if so, find at least one match
      return role.some((role) => role === userRole);
    } else {
      return userRole === role;
    }
  };

  return {
    currentUser,
    loggedUsers,
    userRole,
    isLogged,
    hasAccessRightsOf,
  };
};
